import axios from "@/plugins/axios";

let url = "/api/console/portfolios/:_portfolio/contents";

export default {
    getContents(_portfolio, data){
        return axios.get(`${url.replace(":_portfolio", _portfolio)}`, data).then(result => result.data);
    },
    getContent(_portfolio, data){
        return axios.get(`${url.replace(":_portfolio", _portfolio)}/${data._id}`).then(result => result.data);
    },
    postContent(_portfolio, data){
        return axios.post(`${url.replace(":_portfolio", _portfolio)}`, data).then(result => result.data);
    },
    putContent(_portfolio, data){
        return axios.put(`${url.replace(":_portfolio", _portfolio)}/${data._id}`, data).then(result => result.data);
    },
    deleteContent(_portfolio, data){
        return axios.delete(`${url.replace(":_portfolio", _portfolio)}/${data._id}`).then(result => result.data);
    },
    postImage(_portfolio, data, file){
        var formData = new FormData(); formData.append("image", file);
        var headers = { "Content-Type": "multipart/formdata" };
        return axios.post(`${url.replace(":_portfolio", _portfolio)}/${data._id}/image`, formData, { headers });
    },
    postBefore(_portfolio, data, file){
        var formData = new FormData(); formData.append("before", file);
        var headers = { "Content-Type": "multipart/formdata" };
        return axios.post(`${url.replace(":_portfolio", _portfolio)}/${data._id}/before`, formData, { headers });
    },
}
